module.exports = __webpack_public_path__ + "img/btn_back.7311e825.png";